<template>
	<lcsj-dialog v-model="paramsAccessshow" title="选择商品参数创建商品" :modal="false" @close="closeDialog('perm')" cancel-text="取消" confirm-text="保存" :confirm-loading="isSubmitting" @confirm="paramsSave"><div class="parent-box">
			<el-table :cell-class-name="$moneyCellClass"
				:data="qiujingList"
				:loading="loading"
				:row-key="'keyId'"
				:pagination="false"
				class="lcsj-data-table table-box"
				border
				:highlight-selection-row="true"
				@get-data="GetGoodsParamsList(1)"
				@selection-change="handleQiuJingSelectionChange"
			>
				<el-table-column type="selection" width="65"></el-table-column>
				<el-table-column type="index" width="60" label="序号"></el-table-column>
				<el-table-column prop="paramsValue" label="球镜" width="120"></el-table-column>
				<el-table-column prop="creator" label="创建人" width="120"></el-table-column>
				<el-table-column prop="createTime" label="创建时间" width="180"></el-table-column>
			</el-table>
			<el-table :cell-class-name="$moneyCellClass"
				:data="zhuJingList"
				:loading="loading"
				:row-key="'keyId'"
				:pagination="false"
				class="lcsj-data-table table-box"
				border
				:highlight-selection-row="true"
				@get-data="GetGoodsParamsList(2)"
				@selection-change="handleZhuJingSelectionChange"
			>
				<el-table-column type="selection" width="65"></el-table-column>
				<el-table-column type="index" width="60" label="序号"></el-table-column>
				<el-table-column prop="paramsValue" label="柱镜" width="120"></el-table-column>
				<el-table-column prop="creator" label="创建人" width="120"></el-table-column>
				<el-table-column prop="createTime" label="创建时间" width="180"></el-table-column>
			</el-table>
		</div>
		
	</lcsj-dialog>
</template>

<script>
import { GetGoodsParamsList, CreateGoosInfo } from "@/api/baseDataApi.js";
export default {
	data() {
		return {
		isSubmitting: false, // 提交中（防重复提交）
			paramsAccessshow: false,
			loading: false,
			qiujingList: [],
			zhuJingList: [],
			typeKeyId: "",
			selectQiuJingList: [],
			selectZhuJingList: []
		};
	},
	computed: {},
	watch: {},

	methods: {
		// 关联用户
		paramsAccess(row) {
			this.paramsAccessshow = true;
			this.typeKeyId = row.keyId;
			this.qiujingList = [];
			this.zhuJingList = [];
			this.GetGoodsParamsList(1);
			this.GetGoodsParamsList(2);
		},
		// 获取数据
		GetGoodsParamsList(type) {
			let parmer = {
				type: type
			};
			GetGoodsParamsList(parmer)
				.then((res) => {
					if (res.code == 1) {
						if (type == 1) {
							this.qiujingList = res.data;
						} else {
							this.zhuJingList = res.data;
						}
					} else {
						this.$message({
							type: "error",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.$message.error("加载失败，请稍后再试！");
				});
		},
		// 保存关联参数
		paramsSave() {
			if (this.selectQiuJingList.length == 0) {
				this.$message.warning("请先选择需要关联的球镜信息！");
				return;
			}
			if (this.selectZhuJingList.length == 0) {
				this.$message.warning("请先选择需要关联的柱镜信息！");
				return;
			}
			let parmer = {
				params1KeyIds: this.selectQiuJingList,
				params2KeyIds: this.selectZhuJingList,
				keyIds: [this.typeKeyId]
			};
			CreateGoosInfo(parmer)
				.then((res) => {
					if (res.code == 1) {
						this.selectQiuJingList = [];
						this.selectZhuJingList = [];
						this.typeKeyId = "";
						this.$message({
							type: "success",
							message: "关联参数保存成功"
						});
						this.paramsAccessshow = false;
						this.$parent.getListData();
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.$message.error("关联参数保存失败，请稍后再试！");
				});
		},
		// 关闭编辑、增加弹出框
		closeDialog() {
			this.rightListData = [];
			this.paramsAccessshow = false;
		},
		//球镜选中
		handleQiuJingSelectionChange(val) {
			if (val) {
				//将value中的keyId筛选出来放在数组中
				this.selectQiuJingList = val.map((item) => {
					return item.keyId;
				});
			} else {
				this.selectQiuJingList = [];
			}
		},
		//柱镜选中
		handleZhuJingSelectionChange(val) {
			if (val) {
				this.selectZhuJingList = val.map((item) => {
					return item.keyId;
				});
			} else {
				this.selectZhuJingList = [];
			}
		}
	},
	created() {},
	mounted() {},
	components: {}
};
</script>
<style scoped>
.parent-box {
	display: flex;
	justify-content: space-between;
	text-align: center;
	align-content: center;
}

.table-box {
	/* min-width:100px;
  max-width: 48%; */
	max-height: 100%;
	min-height: 480px;
	text-align: center;
}
</style>
